// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { TerceraButtonEvents } from '@shared/utils/Enums/ButtonEnums';
import PairColorPickerTemplate from '@front/templates/PairColorPickerTemplate.html';
import { ContainerControl } from './ContainerControl';
export class PairColorPicker extends ContainerControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.PairColorChanged = new CustomEvent();
        this.observe('pairColor', this.onPairColorChanged);
    }
    onPairColorChanged(newPairColor) {
        this.fire(TerceraButtonEvents.onPairColorChanged, newPairColor);
        if (!isNullOrUndefined(this.PairColorChanged)) {
            this.PairColorChanged.Raise(this, newPairColor);
        }
    }
}
ContainerControl.extendWith(PairColorPicker, {
    data: function () {
        return {
            pairColor: null,
            colorPickerClicked: null
        };
    },
    template: PairColorPickerTemplate
});
